// extracted by mini-css-extract-plugin
module.exports = {"container":"_3h0Sww","tabListWrap":"_3-bjqi","tablist":"_3xauvx","tab":"_2kKEk6","selected":"uV5Dbw","tabpannel":"_1LTOoH","selectedTabPanel":"_15u-qp"};